import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllContentCategory = lazy(() => import("../pages/all-content-category"));

export const ContentCategoryRouter = [
  {
    path: "/master-management/content-category",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllContentCategory />
          </Suspense>
        ),
      },
    ],
  },
];
